import Vue from 'vue'

// Automated for .vue components
let requireComponent = require.context('./', true, /\w+\.vue$/) // add 'lazy' for dyanmic imports
requireComponent.keys().forEach(filename => {
  let component = requireComponent(filename)
  filename = filename.replace(/.*\/(\w+).vue$/g, '$1')
  Vue.component(component.name || filename, component.default || component) // use () => component for dynamic imports
})